module.exports = __webpack_public_path__ + "img/img_level_10.2b6cd28b.png";